import isUndefined from 'lodash/isUndefined'
import isNaN from 'lodash/isNaN'

export const cleanupCPF = (cpf) => cpf.replace(/\D/g, '')

export const cleanupPhone = (phone) => filterString(phone, ['(', ')', ' ', '-', '_'])

export const cleanupCEP = (cep) => cep.replace('-', '')

export const cleanupCreditCard = (creditCard) => creditCard.replace('.', '').replace('.', '').replace('.', '')

export const blankValue = (value) => (isUndefined(value) || isNaN(value) ? '' : value)

export const filterString = (receivedString, removedValues) => {
  const stringToBeFiltered = String(receivedString)
  let returnedString = ''
  //removed values must be an array of strings/chars
  if (Array.isArray(removedValues)) {
    for (let char of stringToBeFiltered) {
      if (removedValues.includes(char)) {
        continue
      }

      returnedString += char
    }
  }

  return returnedString
}
